module.exports = __webpack_public_path__ + "img/second-day-6.9c8ab617.webp";